import { z } from "zod/v4";
//#region src/schemas/daemon/runtime-reporting-health.ts
const RUNTIME_REPORTING_HEALTH_SCHEMA_VERSION = 1;
const RUNTIME_REPORTING_HEALTH_SCHEMA_NAME = "wakeloop-runtime-reporting-health-v1";
const RUNTIME_REPORTING_FAILURE_REASON_CODE_MAX_LENGTH = 160;
const RUNTIME_REPORTING_FAILURE_MESSAGE_MAX_LENGTH = 500;
const RUNTIME_REPORTING_CHANNELS = ["runtimeAgentController", "providerConversationProof"];
const runtimeReportingChannelSchema = z.enum(RUNTIME_REPORTING_CHANNELS);
const runtimeReportingHealthFailureSchema = z.strictObject({
	at: z.iso.datetime({ offset: true }),
	reasonCode: z.string().min(1).max(160),
	message: z.string().min(1).max(500)
});
const runtimeReportingApplicabilitySchema = z.strictObject({
	status: z.enum(["applicable", "not_applicable"]),
	observedAt: z.iso.datetime({ offset: true })
});
const runtimeReportingServiceIdentitySchema = z.strictObject({
	deviceId: z.string().trim().min(1),
	contractGeneration: z.int().nonnegative()
});
const runtimeReportingChannelHealthSchema = z.strictObject({
	applicability: runtimeReportingApplicabilitySchema.optional(),
	lastSuccessAt: z.iso.datetime({ offset: true }).nullable(),
	consecutiveFailures: z.int().nonnegative(),
	lastFailure: runtimeReportingHealthFailureSchema.nullable()
});
const runtimeReportingHealthStateSchema = z.strictObject({
	schema: z.literal(RUNTIME_REPORTING_HEALTH_SCHEMA_NAME),
	v: z.literal(1),
	serviceIdentity: runtimeReportingServiceIdentitySchema.optional(),
	serviceIdentityObservedAt: z.iso.datetime({ offset: true }).optional(),
	runtimeAgentController: runtimeReportingChannelHealthSchema,
	providerConversationProof: runtimeReportingChannelHealthSchema
});
//#endregion
export { RUNTIME_REPORTING_CHANNELS, RUNTIME_REPORTING_FAILURE_MESSAGE_MAX_LENGTH, RUNTIME_REPORTING_FAILURE_REASON_CODE_MAX_LENGTH, RUNTIME_REPORTING_HEALTH_SCHEMA_NAME, RUNTIME_REPORTING_HEALTH_SCHEMA_VERSION, runtimeReportingApplicabilitySchema, runtimeReportingChannelHealthSchema, runtimeReportingChannelSchema, runtimeReportingHealthFailureSchema, runtimeReportingHealthStateSchema, runtimeReportingServiceIdentitySchema };

//# sourceMappingURL=runtime-reporting-health.js.map